module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"logo":"Design System","description1":"온라인 쇼핑몰의 든든한 파트너,","description2":"크리마 리뷰의 디자인 시스템 아카이브입니다.","see_more":"더 알아보기","design_get_started":{"content":"크리마 리뷰의 디자인 시스템과 디자인 원칙을 소개합니다."},"design_foundations":{"content":"크리마 리뷰 제품의 토대가 되는 디자인 요소에 대한 가이드라인을 제시합니다."},"design_components":{"content":"크리마 리뷰의 PC/Mobile 컴포넌트에 대해 정의하고 가이드라인을 제시합니다."}}}')
  delete Component.options._Ctor
}
